import { Instance, types } from 'mobx-state-tree'

import { emailValidationMessage } from 'utils/validationUtils'

const EmailAddressBaseModel = types
  .model('EmailAddressModel', {
    email_address: types.string,
  })
  .views((self) => ({
    get emailAddress(): typeof self.email_address {
      return self.email_address
    },
    emailValidationMessages(saveInProgress: boolean): string {
      return emailValidationMessage(self.email_address, saveInProgress)
    },
  }))
  .actions((self) => ({
    setEmailAddress(emailAddress: typeof self.emailAddress): void {
      self.email_address = emailAddress
    },
  }))

const ExistingEmailAddressModel = EmailAddressBaseModel.named('ExistingEmailAddressModel')
  .props({
    id: types.identifierNumber
  })
  .views((_self) => ({
    get isNew() {
      return false
    }
  }))

const NewEmailAddressModel = EmailAddressBaseModel.named('NewEmailAddressModel')
.views((_self) => ({
  get isNew() {
    return true
  }
}))

export const EmailAddressModel = types.union(ExistingEmailAddressModel, NewEmailAddressModel)

export type EmailAddress = Instance<typeof EmailAddressModel>
